import React, { useEffect, useState } from "react"
import Loadable from "./Loadable"

import "../scss/font.scss"
import "../scss/base.scss"

const Agreement = Loadable({
    loader: () => import("./Agreement"),
    loading: () => <span />,
})

/**
 * Tab slugs in the same order as the tabs inside <Agreement />, so the standalone
 * page can be deep linked, eg /agreement?tab=privacy
 */
const TAB_SLUGS = ["agreement", "privacy", "disclaimer", "cookies"]

const getTabIndexFromUrl = () => {
    try {
        const tab = new URLSearchParams(window.location.search).get("tab")
        const index = TAB_SLUGS.indexOf((tab || "").toLowerCase())

        return index === -1 ? 0 : index
    } catch (err) {
        return 0
    }
}

/**
 * The terms / privacy / disclaimer / cookie content on its own page, no app, no login.
 * Rendered from index.js when the url is /agreement
 */
const AgreementPage = () => {
    const [tabIndex] = useState(getTabIndexFromUrl)

    useEffect(() => {
        document.title = "missionX. Terms and conditions"

        const body = document.getElementById("dna-body")
        const previousClassName = body ? body.className : ""

        if (body) body.className = "dna-dark dna-dark-bg"

        return () => {
            if (body) body.className = previousClassName
        }
    }, [])

    return (
        <div className="dna-agreement-page">
            <Agreement
                standalone
                activeTabIndex={tabIndex}
                onTabChange={(i) => {
                    try {
                        const slug = TAB_SLUGS[i]
                        const search = slug && i > 0 ? `?tab=${slug}` : ""

                        window.history.replaceState({}, "", `${window.location.pathname}${search}`)
                    } catch (err) {
                        // Nothing, the url is cosmetic here
                    }
                }}
            />
        </div>
    )
}

export default AgreementPage
